module.exports = __webpack_public_path__ + "static/media/kommentaarid.06575f42.png";